(function () {
  class WinningsText extends PIXI.Container {
    ReelsBacking = undefined;
    Reels = undefined;

    constructor() {
      super();
      Reflex.registerEventHandler("ready", this.onReady.bind(this));
    }

    onReady = function () {
      this._container = resourceManager.get(this.name + ":winningsTextContainer");

      this._totalWinText = resourceManager.get(this.name + ":winningsTextContainer:winningsText");

      this.show(false);

      this._textAnimTimeline = undefined;
      this._animOut = undefined;
      this.Reels = resourceManager.get("slotContainer:reelContainer");

      this.ReelsBacking = resourceManager.get("slotContainer:reelContainer:reelsFrame");
    };

    setText = function (value, pos, symbol) {
      var valueText = gdk.formatCurrency(value);
      this._totalWinText.setText(valueText);
      if (pos === undefined) {
        pos = {
          x: this.ReelsBacking.position.x,
          y: this.ReelsBacking.position.y,
        };
      }

      this.position = pos;
      this.symbol = symbol;
    };

    setPos = function (pos) {
      if (pos === undefined) {
        pos = {
          x: this.ReelsBacking.position.x,
          y: this.ReelsBacking.position.y,
        };
      }
      this.position = pos;
      this.scale = { x: 0.3, y: 0.3 };
    };

    resetPosition = function () {
      if (this.symbol !== undefined) {
        const symbol = resourceManager.get(
          `slotContainer:reelContainer:reel${this.symbol.cell.reel}:symbol${this.symbol.cell.row}`
        );

        const pos = helper.getLocalFromGlobalPosition(symbol, this);
        this.position = pos;
        this.scale = { x: 0.3, y: 0.3 };
      } else {
        this.position = {
          x: this.ReelsBacking.position.x,
          y: this.ReelsBacking.position.y,
        };
        this.scale = { x: 0.3, y: 0.3 };
      }
    };

    animate = function (introOnly) {
      const pos = {
        x: this.ReelsBacking.position.x,
        y: this.ReelsBacking.position.y,
      };
      this.position = pos;
      let self = this;
      if (!introOnly) {
        this._textAnimTimeline = gsap.timeline().fromTo(
          self.scale,
          {
            x: 0,
            y: 0,
          },
          {
            duration: 1,
            ease: "back.out(2)",
            x: 1,
            y: 1,
            onStart: () => {
              soundManager.play("winAmountIn");
            },
            onUpdate: () => {
              const pos = {
                x: this.ReelsBacking.position.x,
                y: this.ReelsBacking.position.y,
              };
              this.position = pos;
            },
            onComplete: () => {
              if (!introOnly) {
                self.animateOut();
              }
            },
          }
        );
      }
    };

    animateOut = function () {
      const pos = {
        x: this.ReelsBacking.position.x,
        y: this.ReelsBacking.position.y,
      };
      this.position = pos;
      let self = this;

      this._animOut = gsap.to(self.scale, {
        duration: 0.4,
        ease: "back.in(3)",
        x: 0,
        y: 0,
        onStart: () => {
          soundManager.play("winAmountOut");
        },
        onUpdate: () => {
          const pos = {
            x: this.ReelsBacking.position.x,
            y: this.ReelsBacking.position.y,
          };
          this.position = pos;
        },
        onComplete: () => {},
      });
    };

    cycleAnimate = function () {
      let self = this;

      gsap.fromTo(
        self.scale,
        {
          x: 0,
          y: 0,
        },
        {
          duration: 0.5,
          ease: "back.out(2)",
          x: 0.3,
          y: 0.3,
        }
      );
    };

    skip = function () {
      this._textAnimTimeline?.progress(1);
    };

    show = function (show, value) {
      this._container.visible = show;

      if (value) this.setText(value);
    };

    setWinText = function (showWinText) {
      if (showWinText) {
        this._totalWinText.visible = false;
      } else {
        this._totalWinText.visible = true;
      }
    };

    setScale = function (scale) {
      this._container.scale.set(scale);
    };
  }

  let winningsTextCreator = function (json) {
    return new WinningsText();
  };

  resourceManager.registerObjectType(
    "winningsText",
    winningsTextCreator,
    function () {},
    function () {
      return [];
    }
  );
})();
